export default __webpack_public_path__ + "static/media/sslb.00e44c4a.PNG";